import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import { addTenantFee, getTenantFeeHistory } from '../../../api/sportaloka-client';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';

const defaultValues = {
  fee_type: 'FIX',
  fee_value: 0
};
const schema = yup.object().shape({
  fee_type: yup.string().label('Jenis Fee').required('${label} wajib diisi'),
  fee_value: yup
    .number()
    .label('Nilai Fee')
    .required('${label} wajib diisi')
    .min(0)
    .when('fee_type', {
      is: 'PERCENTAGE',
      then: (schema) => schema.max(100, 'Nilai Fee tidak boleh lebih dari 100'),
      otherwise: (schema) => schema
    })
});

const TenantFee = () => {
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [histories, setHistories] = useState([]);
  const [fetchError, setFetchError] = useState(false);
  const { id } = useParams();

  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const watchFeeType = watch('fee_type', false);

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await addTenantFee(id, val.fee_type, val.fee_value);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Fee tenant berhasil diperbarui',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
      getData();
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: 'Periksa koneksi anda dan coba kembali.',
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  const getData = async () => {
    try {
      setFetchLoading(true);
      setFetchError(false);
      const response = await getTenantFeeHistory(id);
      const responseData = response.data.data;
      if (responseData.length > 0) {
        setHistories(responseData);
        reset({ fee_type: responseData[0].fee_type, fee_value: responseData[0].fee_value });
      }
      setFetchLoading(false);
    } catch (error) {
      setFetchError(true);
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="row">
      {histories.length > 0 && (
        <div className="col-3">
          <div className="history">
            {histories.map((history) => (
              <div className="history__item" key={history.id}>
                <span className="history__item__title">Perubahan Fee Tenant</span>
                <p className="history__item__message">
                  Admin telah mengubah fee tenant menjadi{' '}
                  {history.fee_type === 'PERCENTAGE'
                    ? `${history.fee_value}%`
                    : `IDR ${history.fee_value.toLocaleString('id-ID')}`}
                  .
                </p>
                <p className="history__item__date">
                  {format(history.created_at, 'dd/MM/yyyy HH:mm')}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className={`${histories.length > 0 ? 'col-9' : 'col-12'}`}>
        {fetchLoading && !fetchError && <div className="text-center fw-700 my-4">Loading...</div>}
        {!fetchLoading && fetchError && (
          <div className="text-center fw-700 my-4">
            Gagal mendapatkan data{' '}
            <span className="text-danger cursor-pointer" onClick={getData}>
              Coba lagi
            </span>
          </div>
        )}
        {!fetchLoading && !fetchError && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
              <label>Jenis Fee</label>
              <Controller
                control={control}
                name="fee_type"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div>
                    <select
                      disabled={loading}
                      className="form-control"
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}>
                      <option value="FIX">FIX</option>
                      <option value="PERCENTAGE">PERCENTAGE</option>
                    </select>
                    {Boolean(errors.fee_type) && (
                      <span className="fw-400" style={{ color: 'red' }}>
                        {errors.fee_type.message}
                      </span>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="form-group">
              <label>Nilai Fee per Tamu {watchFeeType === 'PERCENTAGE' ? '(%)' : '(IDR)'}</label>
              <Controller
                control={control}
                name="fee_value"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div>
                    <input
                      disabled={loading}
                      className={`form-control ${Boolean(errors.fee_value) && 'error'}`}
                      type="number"
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                    />
                    {Boolean(errors.fee_value) && (
                      <span className="fw-400" style={{ color: 'red' }}>
                        {errors.fee_value.message}
                      </span>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="form-group text-center">
              <button disabled={loading} type="submit" className="btn bg-blue-1 text-white fw-500">
                <i className="fa fa-save mr-2" />
                <span className="ml-10">{loading ? 'Loading...' : 'Simpan Perubahan'}</span>
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default TenantFee;
